<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="发布新版本"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="150px">
      <el-form-item label="版本号" prop="Version">
        <el-input v-model.trim="item.Version" placeholder="请输入版本号"></el-input>
      </el-form-item>
      <el-form-item label="包含功能版本" prop="FunctionVersion">
        <el-select v-model="item.FunctionVersion" clearable placeholder="请选择功能版本">
          <el-option
            v-for="item in version"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="最低.Net FW版本" prop="MiniNet">
        <el-input v-model.trim="item.MiniNet" placeholder="请输入.Net FW版本"></el-input>
      </el-form-item>
      <el-form-item label="最低操作系统" prop="MiniSystem">
        <el-input v-model.trim="item.MiniSystem" placeholder="请输入操作系统"></el-input>
      </el-form-item>
      <el-form-item label="更新日志" prop="UpdateLog">
        <el-input
          v-model.trim="item.UpdateLog"
          :autosize="{ minRows: 3 }"
          type="textarea"
          placeholder="请输入更新日志"
        ></el-input>
      </el-form-item>
      <el-form-item label="文件上传" prop="file">
        <div class="clearfix">
          <el-button
            type="primary"
            @click="onFileClick"
            class="pull-left"
            style="margin-top: 3px;"
          >选择文件</el-button>
          <el-input v-model="fileName" class="pull-left" style="width: 300px;" :readonly="true"/>
          <div style="display: none;">
            <input ref="file" name="upfile" type="file" @change="changeFile">
          </div>
          <span class="text-danger" v-if="fileName === ''">文件不能为空</span>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting || !fileName">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      submitting: false,
      fileName: null,
      version: [
        {
          value: 1,
          label: '版本1',
        },
        {
          value: 2,
          label: '版本2',
        },
        {
          value: 3,
          label: '版本3',
        },
      ],
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
      this.fileName = null;
      this.submitting = null;
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        const formData = new window.FormData();
        formData.append('file', this.item.file);
        formData.append('SoftWareID', this.item.ID);
        formData.append('Version', this.item.Version);
        formData.append('MiniSystem', this.item.MiniSystem);
        formData.append('MiniNet', this.item.MiniNet);
        formData.append('UpdateLog', this.item.UpdateLog);
        formData.append('FunctionVersion', this.item.FunctionVersion);
        this.$axios.post('software/version', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        }).then(() => {
          this.$message({
            message: '上传成功!',
            type: 'success',
          });
          this.onClose();
          this.$emit('form:saved');
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
        }).finally(() => {
          this.submitting = false;
        });
      });
    },
    onFileClick() {
      this.$refs.file.click();
    },
    changeFile() {
      const reads = new FileReader();
      if (this.$refs.file.files[0]) {
        this.item.file = this.$refs.file.files[0];
        reads.readAsDataURL(this.item.file);
        this.fileName = this.item.file.name;
      }
    },
  },
};
</script>
